<template>
  <div class="analytics-question-photo">
    <h6 class="mb-3">{{ label }}</h6>

    <div v-if="displayPhotos.length > 0 && !loading" class="my-2 flex justify-between">
      <div v-for="(photo, key) in displayPhotos"
           :key="key"
           :class="photosGridClass(key)"
      >
        <ImageAsset
          v-if="photo"
          :key="photo.uuid"
          :photo="photo"
          class="max-h-160px image-bg-cover-no-repeat rounded my-2 cursor-pointer"
          @click="showImage(photo)"
        />
        <div v-else class="h-160px rounded my-2 bg-30 flex">
          <Loader class="self-center" />
        </div>
      </div>
    </div>

    <div v-if="displayPhotos.length === 0 && loading" class="h-160px rounded my-2 bg-30 flex">
      <Loader class="self-center" />
    </div>

    <div v-if="displayPhotos.length === 0 && !loading" class="my-2">
      <p class="text-60">{{ $t('No photos') }}</p>
    </div>

    <router-link v-if="displayPhotos.length >= 2"
                 class="font-semibold text-primary"
                 :to="routeToGallery"
    >
      {{ $t('See all') }}
    </router-link>

    <photo-modal v-if="showModal"
                 :photo="modalPhoto"
                 @close="closeModal"
    />
  </div>
</template>

<script>
  import _ from 'lodash';
  import PhotoModal from '@/_legacy/components/Modals/PhotoModal.vue';
  import Loader from '@/_legacy/components/Icons/Loader.vue';
  import Modal from '@/_legacy/components/Modal.vue';
  import Vue from 'vue';
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';

  Vue.component('modal', Modal);

  // analytics, one photo display on checklist summary
  export default {
    name: 'Photo',
    components: {
      ImageAsset,
      PhotoModal,
      Loader,
    },
    props: {
      questionSet: {
        type: Object,
        default: () => ({}),
      },
      label: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        loading: true,
        photosV1: [],
        photosV2: [],
        showModal: false,
        modalPhoto: null,
        photosArrayResolved: [],
      };
    },
    computed: {
      routeToGallery() {
        return {
          name: 'analyticsSummaryChecklistsPhotos',
          params: { id: this.$route.params.id },
          query: { question: this.displayPhotos[0].uuid },
        };
      },
      displayPhotos() {
        return this.photosArrayResolved.slice(0, 3);
      },
      photosArray() {
        const questions = _.filter(this.questionSet.questions, 'photos');

        return questions
          .filter(question => question.photos && question.photos.length)
          .map(question => question.photos).flat()
          .map(questionsPhoto => {
            const formattedPhotoRecord = {
              drawing_id: questionsPhoto.drawing_v2_id,
              image_id: questionsPhoto.photo_v2_id,
              uuid: questionsPhoto.inspection_question_uuid,
            };

            return formattedPhotoRecord;
          });
      },
    },
    watch: {
      photosArray: {
        handler: 'getPhotos',
        immediate: true,
      },
    },
    methods: {
      photosGridClass(key) {
        return [
          { 'ml-2': key > 0 },
          this.displayPhotos.length > 1 ? `w-1/${this.displayPhotos.length}` : 'w-full',
        ];
      },
      showImage(photo) {
        this.showModal = true;
        this.modalPhoto = photo;
      },
      closeModal() {
        this.showModal = false;
        this.modalPhoto = null;
      },
      getPhotos() {
        this.loading = true;
        const photos = this.photosArray.slice(0, 3).forEach(photo => this.getPhoto(photo));
        this.loading = false;
        return photos;
      },
      getPhoto(photo) {
        if (!photo) {
          return;
        }

        this.photosArrayResolved.push({ ...photo });
      },
    },
  };
</script>
